<template>
  <div class="col-md-12 grid-margin stretch-card">
    <div class="card">
      <div class="card-body" v-if="isLogged">
        <div class="row mb-4">
          <div class="col-md-6">
            <h3 class="font-weight-bold">Gestión de Solicitudes Rechazadas</h3>
          </div>
        </div>


        <div class="white-content-general mb-4">
          <div class="row">
            <div class="col-md-12 col-sm-12">

              <a
                  href="javascript:void(0)"
                  data-toggle="modal"
                  data-target="#modalFiltros"
                  data-backdrop="static"
                  data-keyboard="false"
                  class="btn btn-primary btn-general float-right mb-2 mb-md-0 ml-2"
              >
                <i class="ti-filter menu-icon"></i> Filtrar</a
              >

              <button
                  class="btn btn-primary btn-general float-right mb-2 ml-2"
                  @click="agregarExcepcion(selectedItems)"
                  data-toggle="modal"
                  data-target="#modalExcepcion"
                  data-backdrop="static"
                  data-keyboard="false"
              >
                <span class="icon-play"></span> Procesar
              </button>

              <button
                  @click="descargar"
                  class="btn btn-primary btn-general float-right"
              >
                <span class="icon-download"></span> Descargar
              </button>

            </div>
          </div>
        </div>

        <div class="white-content-table">

          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
              <tr>
                <th></th>
                <th>Id Solicitud</th>
                <th>{{ this.$config.labelActivoId }}</th>
                <th>{{ this.$config.labelTicket }}</th>
                <th>{{ this.$config.labelCodigoCliente }}</th>
                <th>{{ this.$config.labelTipo }}</th>
                <th>{{ this.$config.labelFechaSolicitud }}</th>
                <th>Dias Trascurridos</th>
                <th>{{ this.$config.labelGerenciaGeneral }}</th>
                <th>{{ this.$config.labelGerenciaVentas }}</th>
                <th>{{ this.$config.labelNombreCliente }}</th>
                <th>{{ this.$config.labelEstablecimiento }}</th>
                <th>{{ this.$config.labelDireccion }}</th>
                <th>{{ this.$config.labelTipoCaso }}</th>
                <th>Motivo</th>
                <th v-if="$config.countryFlag==='EC'">Nivel de riesgo</th>
                <th v-if="$config.countryFlag==='EC'">Capacidad</th>
                <th v-if="$config.countryFlag==='EC'">Mediana</th>
              </tr>
              </thead>
              <tbody>

              {{selectItems}}
              <tr v-for="item in solicitudesRechazadas" :key="item">
                <td>
                  <input type="checkbox" @click="selectItem(item)"/>
                </td>
                <td>{{ item.solicitud }}</td>
                <td>{{ item?.activoId }}</td>
                <td>{{ item?.ticketId }}</td>
                <td>{{ item?.pocId }}</td>
                <td>{{ item?.tipoSolicitud }}</td>
                <td>{{ item.fecha }}</td>
                <td>
                  <div
                      class="badge"
                      :class="
                        item.diasTranscurridos < 3
                          ? 'badge-success'
                          : item.diasTranscurridos > 5
                          ? 'badge-danger'
                          : 'badge-warning'
                      "
                  >
                    {{ item.diasTranscurridos }} día(s)
                  </div>
                </td>
                <td>{{ item?.direccionVentas }}</td>
                <td>{{ item?.gerenciaVentas }}</td>
                <td>{{ item?.pocName }}</td>
                <td>{{ item?.pocOwnerName }}</td>
                <td>{{ item?.pocDireccion }}</td>
                <td>{{ item?.origenTicket }}</td>
                <td>{{ item.motivo }}</td>
                <td v-if="$config.countryFlag==='EC'">{{ item.solicitud.prioridad }}</td>
                <td v-if="$config.countryFlag==='EC'">{{ item.solicitud.capacidadEeffMediana }}</td>
                <td v-if="$config.countryFlag==='EC'">{{ item.solicitud.medianaUltimoTrimestre }}</td>
              </tr>
              </tbody>
            </table>
            <br/>
            <div class="d-flex justify-content-center">
              <nav aria-label="Page navigation example" v-if="paginas">
                <ul class="pagination">
                  <li class="page-item" :disabled="pagina === 1">
                    <a class="page-link" @click="setPreviewPage">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li
                      v-for="page in paginas"
                      :key="page"
                      class="page-item"
                      :class="{ active: pagina === page }"
                  >
                    <a class="page-link" @click="setPage(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" :disabled="pagina === paginas">
                    <a class="page-link" @click="setNextPage">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

            <Filtros
                titulo="Seleccionar filtros"
                :consultar="consultarXFiltros"
                entidad="solicitudes_rechazadas_view"
            />

            <AgregarExcepcion
                titulo="Agregar excepción"
                :agregar="procesarAgregarExcepcion"
            />
            <ModalMessages
                :mensaje="mensajeProceso"
                titulo="Agregar excepción"
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AgregarExcepcion from "./AgregarExcepcion.vue";
import ModalMessages from "../../../components/ModalMessages.vue";
import Filtros from "@/components/CustomFilters.vue";

export default {
  name: "GestionSolicitudesRechazadas",
  components: {Filtros, AgregarExcepcion, ModalMessages},
  data() {
    return {
      pagina: 1,
      mensaje: "",
      id: "",
      valorBusqueda: "",
      tipoFiltro: "",
      mensajeProceso: [],
      selectedItems: [],
      totalRegistros: 0,
      inicializarPagina: false,
      paginaFiltros: 1,
    };
  },
  created() {
    if (!this.$store.getters["auth/isLogged"]) {
      this.$store.dispatch("auth/logout");
      return false;
    }
    this.consultarXFiltros(this.data)

  },
  methods: {
    loaderSpinner() {
      this.loader = this.$loading.show();
    },
    async consultar(pagina) {
      this.loaderSpinner();
      this.valorBusqueda = "";
      try {
        const data = {
          pagina: pagina || 1,
        };
        await this.$store.dispatch(
            "solicitudesRechazadas/consultarSolicitudesXPagina",
            data
        );
        await this.$store.dispatch(
            "solicitudesRechazadas/consultarTotalPaginas"
        );
        this.pagina = pagina;
      } catch (error) {
        alert("No se pudo realizar la consulta");
      } finally {
        this.loader.hide();
      }
    },

    setPage(page) {
      this.pagina = page;
    },
    setNextPage() {
      if (this.pagina < this.totalPaginas) {
        this.pagina = this.pagina + 1;
      }
    },
    setPreviewPage() {
      if (this.pagina > 1) {
        this.pagina = this.pagina - 1;
      }
    },
    agregarExcepcion(solicitud) {
      this.$store.commit(
          "solicitudesRechazadas/setSolicitudRechazadaSeleccionada",
          solicitud
      );
    },

    selectItem(check) {
      const findedOption = this.selectedItems?.findIndex(
          (item) => item === check.id
      );

      let arraySelectedItems = [];
      if (findedOption === -1) {
        arraySelectedItems = [...this.selectedItems, check.id];
      } else {
        arraySelectedItems = this.selectedItems.filter(
            (item) => item !== check.id
        );
      }
      this.selectedItems = arraySelectedItems;
    },
    async procesarAgregarExcepcion(data) {

      try {

        await this.$store.dispatch("solicitudesRechazadas/agregarExcepcionesV2", {
          observacion: data.observacion,
          solicitudRechazadas: this.selectedItems,
        });
        await this.consultarXFiltros(data);

        this.mensajeProceso = ["Se agregó la excepxión con éxito"];
        document.getElementById("modalButton").click();
      } catch (error) {
        this.mensajeProceso = ["No se pudo agregar la excepción"];
        document.getElementById("modalButton").click();
      }
    },

    async consultarXFiltros(data) {
      this.condiciones = data?.condiciones;

      this.loaderSpinner();
      try {
        await this.$store.dispatch("solicitudesRechazadas/consultarSolicitudesRechazadasXFiltros", {
          pagina: data?.inicializarPagina ? 1 : this.pagina,
          condiciones: data?.condiciones || [],
        });
        this.totalRegistros = this.$store.getters["solicitudesRechazadas/totalRegistros"];
        if (data?.inicializarPagina) {
          this.setPage(1);
          this.inicializarPagina = false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loader.hide();
      }
    },
    async descargar() {
      if (this.condiciones === undefined) {
        this.condiciones = [];
      }
      this.loaderSpinner();
      try {
        let
            entidad = "solicitudes_rechazadas_view"
        const resp = await this.$store.dispatch("exportar/exportar", {
          entidad: entidad,
          filtro: {
            condiciones: this.condiciones
          }
        });
        if (resp) {
          const url = window.URL.createObjectURL(new Blob([resp]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `rechazadas.csv`);
          document.body.appendChild(link);
          link.click();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loader.hide();
      }
    },
  },
  computed: {
    isLogged() {
      return this.$store.getters["auth/isLogged"]
          ? this.$store.getters["auth/isLogged"]
          : false;
    },
    solicitudesRechazadas() {
      return this.$store.getters["solicitudesRechazadas/solicitudesRechazadas"]
          ? this.$store.getters["solicitudesRechazadas/solicitudesRechazadas"]
          : [];
    },
    totalPaginas() {
      return this.$store.getters["solicitudesRechazadas/totalPaginas"]
          ? this.$store.getters["solicitudesRechazadas/totalPaginas"]
          : 0;
    },
    paginas() {
      let numeroPaginas = 10;
      numeroPaginas = Math.min(numeroPaginas, this.totalPaginas);
      let first = this.pagina - Math.floor(numeroPaginas / 2);
      first = Math.max(first, 1);
      first = Math.min(first, this.totalPaginas - numeroPaginas + 1);
      return [...Array(numeroPaginas)].map((k, i) => i + first);
    },
  },
  watch: {
    pagina(newPage, oldPage) {
      if (!newPage) return;

      if (newPage !== oldPage) {
        this.consultarXFiltros({
          condiciones: this.condiciones,
          inicializarPagina: false,
        });
      }
    },
  },
};
</script>
